import { ViewModel,View } from "binder"
import  { CreateWarehouseKeepingView } from "./createWarehouseKeeping-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WarehouseKeepingListViewModel } from "../warehouseKeepingList/warehouseKeepingList-viewModel";
import { WarehouseSelectorViewModel } from "src/Warehouse/warehouseManipulation/warehouseManipulation-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class CreateWarehouseKeepingViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: WarehouseKeepingListViewModel) {
        super(parentViewModel);
        this._typedParent = parentViewModel;
        this.warehouseSelector = new WarehouseSelectorViewModel(this);
    }
    GetDefaultView(): View <ViewModel> {
        return new CreateWarehouseKeepingView();
    }
    public getTypeId(): string {
        return "VM-A2C42B13-AC1D-4F7B-94D4-D6F7AE9F64AF"
    }closePopup(resultCode?: string) {
        this._typedParent.refreshClosePopups();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set warehouseSelector(v: WarehouseSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelectorViewModel { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelectorViewModel;
    public set useDefaultValue(v: boolean) { this._useDefaultValue = v; } public get useDefaultValue(): boolean { return this._useDefaultValue;} private _useDefaultValue: boolean;
    
    private _typedParent : WarehouseKeepingListViewModel;

    async save () {
        try {
            let confirmation ='';
            confirmation = await this.messageBoxWarningYesNo('آیا انبارگردانی جدید ایجاد شود؟','ایجاد انبارگردانی');
            if(confirmation=='no'){
                return;
            }
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/WarehouseKeepingServices/CreateNewWarehouseKeeping',{
                WarehouseId: this.warehouseSelector.selectedItem?.id,
                UseCurrentAmountAsDefault: this.useDefaultValue
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            await this.messageBoxConfirmSuccess('انبارگردانی جدید با موفقیت ایجاد شد.','عملیات موفق');
            this.closePopup('done');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async back() {
        this.closePopup();
    }
}
